import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { useAlertTimer } from '../../hooks/useAlertTimer';
import { sharedUiTranslations } from '../../translations';
import { Icon } from '../Icon';
import styles from './Alert.module.css';
const APPEARANCE_ICON_MAP = {
    error: 'inputError',
    success: 'successGreen',
    info: 'informationFilled',
    warning: 'warning',
    neutral: 'neutral',
};
const getIconName = (appearance) => {
    return APPEARANCE_ICON_MAP[appearance] || appearance;
};
export const AlertBase = ({ message, duration = 0, alertType = 'toast', appearance = 'info', hideCloseButton = false, iconPresentation = false, customIconName, isHidden = false, density = 'compact', testIdIdentifier = 'alert', className = '', alignItems = 'standard', position = 'right', onClose, }) => {
    const { t } = useTranslation();
    useAlertTimer({ duration, onClose });
    if (isHidden)
        return null;
    const alertClass = [
        styles.alert,
        styles[alertType],
        styles[appearance],
        styles[density],
        styles[`alignitems${alignItems}`],
        alertType === 'toast' ? styles[`position${position}`] : '',
        className,
    ].join(' ');
    return (_jsxs("div", { className: alertClass, role: alertType === 'toast' ? 'alert' : undefined, "data-testid": testIdIdentifier, children: [!iconPresentation && (_jsx(Icon, { name: customIconName ?? getIconName(appearance), alt: appearance, className: styles.alertIcon, "aria-hidden": iconPresentation, "data-testid": `${testIdIdentifier}-icon` })), _jsx("span", { className: styles.alertText, "data-testid": `${testIdIdentifier}-text`, children: message }), !hideCloseButton && onClose && (_jsx("button", { type: 'button', className: styles.alertClose, onClick: e => {
                    e.stopPropagation();
                    onClose();
                }, "aria-label": t('alert.close'), "data-testid": `${testIdIdentifier}-close`, children: _jsx(Icon, { name: 'actionClose', alt: t('alert.close'), className: styles.alertCloseIcon }) }))] }));
};
export const Alert = props => {
    return (_jsx(TranslationProvider, { translations: sharedUiTranslations, defaultLanguage: 'pt-BR', children: _jsx(AlertBase, { ...props }) }));
};
